import { useRef, useState } from "react";

// 목록 정렬 - 헤더 버튼 클릭 시 (asc : 오름차순, desc:내림차순, default: 처음정렬기준으로)
const ASC = "asc";
const DESC = "desc";
const DEFAULT = "default";
const SORT_TYPES = [DEFAULT, ASC, DESC];

interface Params {
  list: any[];
}

const useSort = ({ list }: Params) => {
  const [sortList, setSortList] = useState(list);
  const sortTypeIndex = useRef(0);

  const handleSort = ({ sortKey }: { sortKey: string }) => {
    const prevIndex = sortTypeIndex.current;
    sortTypeIndex.current =
      prevIndex === SORT_TYPES.length - 1 ? 0 : prevIndex + 1;

    const sortType = SORT_TYPES[sortTypeIndex.current];

    if (sortType === DEFAULT) {
      setSortList(list);
      return;
    }

    const newSortList = [...sortList].sort((a, b) => {
      // 키값 타고 타고 들어가기
      const keys = sortKey.split(".");
      keys.forEach((key) => {
        a = a[key];
        b = b[key];
      });

      if (sortType === ASC) {
        if (a > b) return 1;
        if (a === b) return 1;
        if (a < b) return -1;
      }

      if (a < b) return 1;
      if (a === b) return 0;
      return -1;
    });

    setSortList(newSortList);
  };

  return { handleSort, sortList };
};

export default useSort;
